<template>
  <div>
    <div class="title">
      <h5>Basic Information</h5>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="input-block">
          <label class="form-label"
            >Course Title<span class="text-danger ms-1">*</span></label
          >
          <input
            type="text"
            class="form-control"
            placeholder="Masukkan judul course"
            v-model="addCourseForm.title"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="input-block">
          <label class="form-label"
            >Instructor<span class="text-danger ms-1">*</span></label
          >
          <vSelect
            class="vselect-custom"
            :options="instructorOptions"
            id="course-category"
            placeholder="Instructor"
            v-model="addCourseForm.instructor"
            :reduce="(option) => option.value"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-block">
          <label class="form-label"
            >Course Group<span class="text-danger ms-1">*</span></label
          >
          <vSelect
            class="vselect-custom"
            :options="courseFetchStore.groupList"
            :get-option-label="
              (group) => `${group.code} - ${group.name || ''}`
            "
            :reduce="(group) => group.course_group_id"
            id="course-category"
            placeholder="Group"
            v-model="addCourseForm.course_group_id"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-block">
          <label class="form-label"
            >Course Level<span class="text-danger ms-1">*</span></label
          >
          <vSelect
            class="vselect-custom"
            :options="levelOptions"
            placeholder="Pilih Level"
            v-model="addCourseForm.level"
            @update:modelValue="onLevelChange"
          />
        </div>
      </div>
      <div
        class="col-md-12"
        v-if="addCourseForm.level && addCourseForm.level !== 'Fundamental'"
      >
        <div class="input-block">
          <label class="form-label"
            >Prerequisite Course (Fundamental)<span class="text-danger ms-1">*</span></label
          >
          <vSelect
            class="vselect-custom"
            :options="fundamentalCourseOptions"
            :get-option-label="(c) => `${c.title} (${c.level || 'Fundamental'})`"
            :reduce="(c) => c.course_id"
            placeholder="Pilih Course Level Fundamental Sebelumnya"
            v-model="addCourseForm.prerequisite_course"
          />
          <small class="text-muted fs-12 mt-1 d-block">
            Siswa wajib menyelesaikan course Fundamental ini sebelum dapat mengakses course ini.
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-block">
          <label class="form-label">Tanggal Course Expired</label>
          <VueDatePicker
            input-class="dp-custom-input"
            v-model="addCourseForm.expired_date"
            :enable-time-picker="false"
            placeholder="Pilih tanggal"
            auto-apply
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-block">
          <label class="form-label"
            >Duration (Days)<span class="text-danger ms-1">*</span></label
          >
          <input
            type="number"
            min="1"
            class="form-control"
            placeholder="Masukkan durasi dalam hari (contoh: 7)"
            v-model.number="addCourseForm.duration"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div class="input-block">
          <label class="form-label"
            >Short Description<span class="text-danger ms-1">*</span></label
          >
          <input
            type="text"
            class="form-control"
            placeholder="Masukkan deskripsi singkat"
            v-model="addCourseForm.short_description"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="input-block">
          <label class="form-label"
            >Course Description<span class="text-danger ms-1">*</span></label
          >
          <div class="summernote">
            <ckeditor
              :editor="editor"
              v-model="addCourseForm.description"
              :config="editorConfig"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { onMounted, computed, watch } from "vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useCourseDataStore } from "@/stores/course/course-data-store";
import VueDatePicker from "@vuepic/vue-datepicker";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store.js";
import { useUserStore } from "@/stores/user/user-store.js";
import { useAuthStore } from "@/stores/auth-store";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";

export default {
  components: {
    VueDatePicker,
    BaseLoading,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorData: null,
      editorConfig: {},
      Course: [
        "Select",
        "Management",
        "IT & Softwares",
        "Marketing",
        "Finance",
        "Productivity",
      ],
      Courselevel: ["Select", "Beginner", "Intermediate", "Advanced", "Expert"],
      Language: ["Select", "French", "German", "Arabic"],
      Privatecourse: ["Select", "Private", "Public"],
      course: [],
      requirements: [],
    };
  },
  methods: {
    addNewItem() {
      this.course.push({
        course: "",
      });
    },
    deleteItem(index) {
      this.course.splice(index, 1);
    },
    addNewRequirements() {
      this.requirements.push({
        requirements: "",
      });
    },
    deleteRequirements(index) {
      this.requirements.splice(index, 1);
    },
  },
  setup() {
    const CourseDataStore = useCourseDataStore();
    const courseFetchStore = useCourseFetchStore();
    const userStore = useUserStore();
    const authStore = useAuthStore();
    const sharedStore = useSharedStore();
    const route = useRoute();

    const addCourseForm = computed(() => CourseDataStore.addCourseForm);

    const instructorOptions = computed(() => {
      const activeOnly = userStore.ActiveTeachers.filter(
        (teacher) => !teacher.deleted_at // true kalau deletedAt null / undefined
      );
      console.log(activeOnly)
      return userStore.getNamesFromActiveList(activeOnly);
    });

    const levelOptions = computed(() => {
      if (
        courseFetchStore.difficultyList &&
        courseFetchStore.difficultyList.length > 0
      ) {
        return courseFetchStore.difficultyList.map((item) =>
          typeof item === "object" && item !== null
            ? item.level || item.name
            : item
        );
      }
      return ["Fundamental", "Intermediate", "Advanced"];
    });

    const fundamentalCourseOptions = computed(() => {
      const currentCourseId = route.params.courseID
        ? Number(route.params.courseID)
        : null;
      return (courseFetchStore.courseList || []).filter((c) => {
        const isFundamental =
          String(c.level || "").trim().toLowerCase() === "fundamental";
        const isNotSelf =
          currentCourseId == null ||
          Number(c.course_id ?? c.id) !== currentCourseId;
        return isFundamental && isNotSelf;
      });
    });

    const onLevelChange = (newLevel) => {
      CourseDataStore.addCourseForm.level = newLevel;
      if (newLevel === "Fundamental") {
        CourseDataStore.addCourseForm.prerequisite_course = null;
      }
      const defaults = {
        Fundamental: 7,
        Intermediate: 14,
        Advanced: 21,
      };
      if (!CourseDataStore.addCourseForm.duration && defaults[newLevel]) {
        CourseDataStore.addCourseForm.duration = defaults[newLevel];
      }
    };

    onMounted(async () => {
      await courseFetchStore.fetchGroupList();
      await courseFetchStore.fetchDifficultyList();
      await courseFetchStore.fetchCourseList();
      await userStore.fetchTeachers();
    });

    watch(
      () => route.params.courseID,
      async (courseId) => {
        if (courseId) {
          await CourseDataStore.loadCourseForEdit(courseId);
        }
      },
      { immediate: true }
    );

    return {
      CourseDataStore,
      addCourseForm,
      courseFetchStore,
      userStore,
      authStore,
      instructorOptions,
      levelOptions,
      fundamentalCourseOptions,
      onLevelChange,
      sharedStore,
    };
  },
};
</script>
<style>
.vselect-custom {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  min-height: 38px;
  padding: 0;
  font-size: 0.875rem;
}

.vselect-custom .vs__dropdown-toggle {
  border: none;
  padding: 0.375rem 0.75rem;
  background-color: white;
}
</style>
